import { action, computed, makeAutoObservable, observable } from "mobx";

class HeaderStore {
  @observable _pageTitle = 'PAS';
  @observable _pageSubTitle = '';

  @observable private _isDoneAssess: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  @action
  setPageTitle = (pageTitle: string) => {
    this._pageTitle = pageTitle;
  };
  @action
  setPageSubTitle = (pageSubTitle: string) => {
    this._pageSubTitle = pageSubTitle;
  };
  @action
  setIsDoneAssess(isDoneAssess: boolean) {
    this._isDoneAssess = isDoneAssess;
  }

  @computed
  get pageTitle() {
    return this._pageTitle;
  }
  @computed
  get pageSubTitle() {
    return this._pageSubTitle;
  }

  @computed
  get isDoneAssess() {
    return this._isDoneAssess;
  }
}

export default HeaderStore;
